module.exports = __webpack_public_path__ + "img/melanie-jovanovic.752d9423.jpeg";